import FilterLabelFormatter from '../FilterLabelFormatter'

import BoardStandardWFFMDataExchange from '@/services/BoardStandardWFFMDataExchange'

/**
 * A mixin adding board standard editing logic and data
 */
export default {
  mixins: [
    FilterLabelFormatter,
  ],
  data () {
    return {
      dx: { boardStandard: new BoardStandardWFFMDataExchange(this.form) },
      popups: { boardStandard: false },
      boardStandards: [],
    }
  },
  created () {
    this.boardStandards = this.dx.boardStandard.data
  },
  computed: {
    selectedBoardStandards () {
      return this.boardStandards.filter(boardStandard => boardStandard.selected)
    },
    selectedBoardStandardLabel () {
      return this.getFormattedFilterLabel(this.selectedBoardStandards, 'Wyżywienie')
    },
    selectedBoardStandardValue () {
      return this.getFormattedFilterValue(this.selectedBoardStandards, 'Wyżywienie')
    },
  },
}


// WEBPACK FOOTER //
// ./src/components/search/logic/BoardStandard.js